module.exports = __webpack_public_path__ + "static/media/imagine.9ca769cc.svg";